import { posStore } from '../nav/posStore.js';
import { useWeatherStore } from './weatherStore.js';
import { useTideStore } from './tideStore.js';
import { useConditionsSourcesStore } from './sourcesStore.js';

/**
 * Wires weather/tide fetching to live GPS fixes app-wide (spec 11/12), same
 * shape as `initTrail()`: load whatever was last persisted immediately (so a
 * cold start shows stale data before the first fix arrives), then fetch on
 * every fix per each store's own moved/stale rule.
 */
export function initConditions(): void {
  void useWeatherStore.getState().init();
  void useTideStore.getState().init();
  void useConditionsSourcesStore.getState().load();

  posStore.subscribe((s, prev) => {
    if (s.fix !== prev.fix && s.fix) {
      useWeatherStore.getState().maybeFetch(s.fix.lat, s.fix.lon);
      useTideStore.getState().maybeFetch(s.fix.lat, s.fix.lon);
    }
  });
}
